import React, { useState, useEffect } from 'react';
import { Box } from '@mui/material';
import LoadingSpinner from '../comp/gen/LoadingSpinner';
import UserAuthRequired from '../comp/gen/UserAuthRequired';
import AppDocuServiceActivityPage from './AppDocu/AppDocuServiceActivityPage';
import AppDocuServiceCall from './AppDocu/_Utils/AppDocuServiceCall';

const AppDocuActivityPage = (props) => {
  const [userState, setUserState] = useState('init');
  
  useEffect(() => {
    document.title = 'Activity - AppDocu';
    checkUser();
    // eslint-disable-next-line
  }, []);

  const checkUser = async () => {
    try {
      const res = await AppDocuServiceCall.checkUser();
      if (res.data && res.data.is_valid === false) {
        setUserState('notAllowed');
      } else {
        setUserState('valid');
      }
    } catch (error) {
      setUserState('error');
    }
  };

  if (userState === 'init') return <LoadingSpinner />;
  if (userState === 'notAllowed') return <UserAuthRequired notallowed={true} />;
  if (userState === 'error') return <UserAuthRequired text="Loading error." />;

  const navbarHeightPx = parseInt(props.navbarHeight, 10) || 0;
  const mainBoxStyle = {
    p: 0,
    m: 0,
    width: '100vw',
    minHeight: `calc(100vh - ${navbarHeightPx}px)`,
    position: 'relative',
    left: '50%',
    right: 0,
    transform: 'translateX(-50%)',
    background: 'transparent',
    boxSizing: 'border-box',
    overflow: 'auto',
  };

  return (
    <Box sx={mainBoxStyle}>
      <Box sx={{ width: '100%', overflow: 'auto', p: 0 }}>
        <AppDocuServiceActivityPage navbarHeight={navbarHeightPx + 'px'} />
      </Box>
    </Box>
  );
};

export default AppDocuActivityPage;
